<template>
  <div class="onboarding-wrapper">
    <div class="container">
      <div class="card">
        <p class="m-text bold">Liste</p>
        <div v-for="video of videoList" class="item" :class="{ 'active': video.id === currentVideo.id }" @click="changeVideoTo(video)">{{ video.title }}</div>
      </div>
    </div>
    <div class="container">
      <div class="card">
        <p class="bold">{{ currentVideo.title }}</p>
        <p class="text">
          {{ $t("app.profil.tutorial.desc") }}
        </p>
        <div class="video-wrapper">
          <iframe
            :src="videoUrl"
            frameborder="0"
            allowfullscreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

interface VideoInfo {
  id: string,
  title: string,
  linkId: string,
}

const videoList = computed(() => {
  return [
    {
      id: 'global',
      title: "Introduction globale",
      linkId: t('app.profil.tutorial.video').split('v=')[1],
    },
    {
      id: 'add-talent',
      title: "Comment ajouter un talent",
      linkId: t('app.profil.tutorial.video').split('v=')[1],
    },
    {
      id: 'see-results',
      title: "Comment consulter les résultats",
      linkId: t('app.profil.tutorial.video').split('v=')[1],
    }
  ] as VideoInfo[];
});

const currentVideo = ref(videoList.value[0]);

const videoId = t('app.profil.tutorial.video').split('v=')[1];
const videoUrl = computed(() =>
  `https://www.youtube.com/embed/${currentVideo.value.linkId}?controls=1`
);

function changeVideoTo(video: VideoInfo) {
  currentVideo.value = video;
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.text {
  font-size: 14px;
}

.onboarding-wrapper {
  display: flex;
  width: 100%;
  gap: 24px;
  margin-top: 16px;

  .container {
    flex: 1;
    flex-basis: 50%;
  }

  .card {
    gap: 12px;
    padding: 32px;

    h2 {
      margin-bottom: 0;
    }

    .item {
      cursor: pointer;
      border-radius: 4px;
      padding: 4px 6px;
      border: 1px solid var(--white-color);

      &:hover {
        background-color: var(--primary-300-color) !important;
        border: 1px solid $primary-color;
        color: $secondary-color;
      }

      &.active {
        background-color: var(--primary-100-color);
        border: 1px solid $primary-color;
      }
    }
  }

  .video-wrapper {
    position: relative;
    margin-top: 24px;
    width: 532px;
    height: 299px;
    overflow: hidden;
    border-radius: 12px;
  }

  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
